import { Modal } from '@hologram-dimension/modal';
import clsx from 'clsx/lite';
import ExportSims from 'components/ExportSims/ExportSims';
import { useCallback, useState, type FC } from 'react';
import useAnalytics from 'state/contexts/Analytics/useAnalytics';
import globalStyles from 'styles/shared.module.css';
import {
  EnumSimInventoryExportType,
  type HologramSimIdsMap,
  type SimInventorySegmentName,
} from 'types/common';
import { formatNumber } from 'utils/numbers';
import type { CommonModalProps } from '../shared';

interface ExportSimsModalProps extends CommonModalProps {
  sims: HologramSimIdsMap;
  onDone?: () => void;
  className?: string;
  exportType: EnumSimInventoryExportType;
  segmentName: SimInventorySegmentName;
}

const ExportSimsModal: FC<ExportSimsModalProps> = ({
  onClose,
  defaultOpen = false,
  className,
  sims,
  onDone,
  exportType,
  segmentName,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const { sendAnalyticsEvent } = useAnalytics();

  const handleClose = useCallback(() => {
    if (onDone) {
      onDone();
    }

    if (sendAnalyticsEvent) {
      sendAnalyticsEvent(`SIMs - ${segmentName} - Export SIMs - Close`);
    }

    onClose();
  }, [onClose, onDone, segmentName, sendAnalyticsEvent]);

  return (
    <Modal
      className={clsx(globalStyles.sharedLoadingAnimationParent, className)}
      header={
        !sims.size || sims.size === 1 ? 'Export SIM' : `Export ${formatNumber(sims.size)} SIMs`
      }
      onClosed={handleClose}
      open={open}
      setOpen={setOpen}
      noContentPadding
    >
      <ExportSims sims={sims} exportType={exportType} segmentName={segmentName} />
    </Modal>
  );
};

export default ExportSimsModal;
